import { SelectionOptionsRendererModule } from './../../../pages/settings/selection-options/selection-options-renderer/selection-options-renderer.module';
import { SettingsRendererModule } from './../../../pages/settings/general-settings/settings-renderer/settings-renderer.module';
import { ControlPopUpModule } from './../../../widgets/control-pop-up/control-pop-up.module';
import { ConfirmationPopUpModule } from './../../../widgets/confirmation-pop-up/confirmation-pop-up.module';
import { FooterModule } from './../../footer/footer.module';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { DxLoadPanelModule, DxNumberBoxModule, DxScrollViewModule, DxTabsModule } from 'devextreme-angular';
import { TaskPopupModule } from 'src/app/pages/task/task-popup/task-popup.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPageLayoutComponent } from './common-page-layout.component';
import { NavbarModule } from '../../navigation/navbar/navbar.module';
import { FiltersGroupSettingsRendererComponent } from 'src/app/widgets/filters/filters-group-settings-renderer/filters-group-settings-renderer.component';

@NgModule({
	declarations: [
		CommonPageLayoutComponent
	],
	imports: [
		CommonModule,

		NavbarModule,
		FooterModule,

		TaskPopupModule,
		ConfirmationPopUpModule,
		ControlPopUpModule,
		SettingsRendererModule,
		SelectionOptionsRendererModule,
		FiltersGroupSettingsRendererComponent,

		DxLoadPanelModule,
		DxContextMenuModule,
		DxScrollViewModule,
		DxTabsModule,
		DxNumberBoxModule,
	],
	exports: [
		CommonPageLayoutComponent,
	],
})
export class CommonPageLayoutModule { }
